import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const CoordinateSchema = z.object({ x: z.number(), y: z.number() });
export type Coordinate = z.infer<typeof CoordinateSchema>;
export interface ICoordinate extends z.ZodType<Coordinate> {}

export enum CellType {
  RACK = "RACK",
  WALKWAY = "WALKWAY",
}

export enum Direction {
  UP = "UP",
  DOWN = "DOWN",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

const WarehouseCellBase = z.object({
  x: z.number(),
  y: z.number(),
  type: createEnum(CellType, { enumName: "CellType" }),
});

export const RackCellSchema = WarehouseCellBase.extend({
  type: z.literal(CellType.RACK),
  bins: z.array(z.string()),
  accessibleDirections: z.array(
    createEnum(Direction, { enumName: "Direction" }),
  ),
  name: z.string().nullish(),
  shelfCount: z.number().nullish(),
  rowName: z.string().nullish(),
});
export type RackCell = z.infer<typeof RackCellSchema>;
export interface IRackCell extends z.ZodType<RackCell> {}

export const WalkwayCellSchema = WarehouseCellBase.extend({
  type: z.literal(CellType.WALKWAY),
});
export type WalkwayCell = z.infer<typeof WalkwayCellSchema>;

export const WarehouseCellSchema = z.discriminatedUnion("type", [
  RackCellSchema,
  WalkwayCellSchema,
]);

export type WarehouseCell = z.infer<typeof WarehouseCellSchema>;

export const WallSchema = z.object({
  from: CoordinateSchema,
  to: CoordinateSchema,
});
export type Wall = z.infer<typeof WallSchema>;
